var _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBriefcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.0 0.0 133.60629921259843 100.0",
    fill: "none",
    stroke: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "p.0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0l133.6063 0l0 100.0l-133.6063 0l0 -100.0z",
    clipRule: "nonzero"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p.0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m0 0l133.6063 0l0 100.0l-133.6063 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7f6000",
    d: "m1.511815 24.884916l0 0c0 -3.2838364 2.6620755 -5.9459114 5.945912 -5.9459114l118.69126 0c1.5769501 0 3.0893097 0.62644196 4.2043915 1.741518c1.1150818 1.1150742 1.7415161 2.6274395 1.7415161 4.2043934l0 23.782934c0 3.2838364 -2.6620789 5.945915 -5.9459076 5.945915l-118.69126 0c-3.2838364 0 -5.945912 -2.6620789 -5.945912 -5.945915z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#7f6000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m1.511815 24.884916l0 0c0 -3.2838364 2.6620755 -5.9459114 5.945912 -5.9459114l118.69126 0c1.5769501 0 3.0893097 0.62644196 4.2043915 1.741518c1.1150818 1.1150742 1.7415161 2.6274395 1.7415161 4.2043934l0 23.782934c0 3.2838364 -2.6620789 5.945915 -5.9459076 5.945915l-118.69126 0c-3.2838364 0 -5.945912 -2.6620789 -5.945912 -5.945915z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7f6000",
    d: "m45.15097 2.5723095l0 0c0 -0.54214287 0.4394951 -0.9816364 0.98163605 -0.9816364l4.0947037 0l0 0c0.26034927 0 0.51003265 0.103422046 0.6941223 0.28751457c0.18409348 0.18409252 0.28751755 0.43377566 0.28751755 0.69412184l0 3.9264278c0 0.54214287 -0.4394951 0.9816365 -0.98163986 0.9816365l-4.0947037 0l0 0c-0.54214096 0 -0.98163605 -0.43949366 -0.98163605 -0.9816365z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#7f6000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m45.15097 2.5723095l0 0c0 -0.54214287 0.4394951 -0.9816364 0.98163605 -0.9816364l4.0947037 0l0 0c0.26034927 0 0.51003265 0.103422046 0.6941223 0.28751457c0.18409348 0.18409252 0.28751755 0.43377566 0.28751755 0.69412184l0 3.9264278c0 0.54214287 -0.4394951 0.9816365 -0.98163986 0.9816365l-4.0947037 0l0 0c-0.54214096 0 -0.98163605 -0.43949366 -0.98163605 -0.9816365z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7f6000",
    d: "m82.69879 2.5723095l0 0c0 -0.54214287 0.43949127 -0.9816364 0.98163605 -0.9816364l4.0947037 0l0 0c0.26034546 0 0.510025 0.103422046 0.6941223 0.28751457c0.18408966 0.18409252 0.28751373 0.43377566 0.28751373 0.69412184l0 3.9264278c0 0.54214287 -0.43949127 0.9816365 -0.98163605 0.9816365l-4.0947037 0l0 0c-0.5421448 0 -0.98163605 -0.43949366 -0.98163605 -0.9816365z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#7f6000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m82.69879 2.5723095l0 0c0 -0.54214287 0.43949127 -0.9816364 0.98163605 -0.9816364l4.0947037 0l0 0c0.26034546 0 0.510025 0.103422046 0.6941223 0.28751457c0.18408966 0.18409252 0.28751373 0.43377566 0.28751373 0.69412184l0 3.9264278c0 0.54214287 -0.43949127 0.9816365 -0.98163605 0.9816365l-4.0947037 0l0 0c-0.5421448 0 -0.98163605 -0.43949366 -0.98163605 -0.9816365z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7f6000",
    d: "m45.1679 4.4685493l6.057976 0l0 19.772566l-6.057976 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#7f6000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m45.1679 4.4685493l6.057976 0l0 19.772566l-6.057976 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7f6000",
    d: "m82.69879 4.4685493l6.057976 0l0 19.772566l-6.057976 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#7f6000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m82.69879 4.4685493l6.057976 0l0 19.772566l-6.057976 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7f6000",
    d: "m87.86204 1.514494l0 6.057978l-41.522392 0l0 -6.057978z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#7f6000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m87.86204 1.514494l0 6.057978l-41.522392 0l0 -6.057978z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7f6000",
    d: "m1.511815 68.75708l0 0c0 -3.2838364 2.6620755 -5.9459114 5.945912 -5.9459114l118.69126 0c1.5769501 0 3.0893097 0.62644196 4.2043915 1.7415199c1.1150818 1.1150742 1.7415161 2.6274414 1.7415161 4.2043915l0 23.782936c0 3.2838364 -2.6620789 5.945915 -5.9459076 5.945915l-118.69126 0c-3.2838364 0 -5.945912 -2.6620789 -5.945912 -5.945915z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#7f6000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m1.511815 68.75708l0 0c0 -3.2838364 2.6620755 -5.9459114 5.945912 -5.9459114l118.69126 0c1.5769501 0 3.0893097 0.62644196 4.2043915 1.7415199c1.1150818 1.1150742 1.7415161 2.6274414 1.7415161 4.2043915l0 23.782936c0 3.2838364 -2.6620789 5.945915 -5.9459076 5.945915l-118.69126 0c-3.2838364 0 -5.945912 -2.6620789 -5.945912 -5.945915z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7f6000",
    d: "m132.0949 45.644638l0 10.306976l-130.58308 0l0 -10.306976z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#7f6000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m132.0949 45.644638l0 10.306976l-130.58308 0l0 -10.306976z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7f6000",
    d: "m132.0949 62.81117l0 10.3069725l-130.58308 0l0 -10.3069725z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#7f6000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m132.0949 62.81117l0 10.3069725l-130.58308 0l0 -10.3069725z",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.ec94f9488cdce3b64e4083df844d59a0.svg";
export { ForwardRef as ReactComponent };